import { ScheduleMethodType } from 'app/modules/posts/types/ScheduleMethodType';
import { faCircleArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faCircleArrowUpRight';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';

import { faCircleDot } from '@fortawesome/pro-regular-svg-icons/faCircleDot';

type Post = {
  type: number;
  subtype: number;
  page: {
    type: number;
  };
};

type OptionConfig = {
  option: ScheduleMethodType;
  icon?: IconDefinition;
  tooltip?: string;
  infoIcon?: {
    icon: IconDefinition;
    tooltip: string;
  };
  disabledTooltip?: string;
  dataName: string;
  dataCy: string;
};

export const facebookScheduleOptions: Record<ScheduleMethodType, OptionConfig> =
  {
    createDarkPost: {
      option: 'createDarkPost' as const,
      dataName: 'posts-preview-schedule-create-dark-post',
      dataCy: 'post-create-dark-post-dropdown-option',
      icon: faCircleDot,
      tooltip: 'createDarkPostTooltip',
      disabledTooltip: 'createDarkPostDisabledTooltip',
      infoIcon: {
        icon: faInfoCircle,
        tooltip: 'createDarkPostTooltip',
      },
    },
    publishNow: {
      option: 'publishNow' as const,
      dataName: 'posts-preview-schedule-publish-now',
      dataCy: 'post-publish-now-dropdown-option',
      icon: faCircleCheck,
      tooltip: 'publishNowTooltip',
      disabledTooltip: 'publishNowDisabledTooltip',
    },
    exportInAdvance: {
      option: 'exportInAdvance' as const,
      icon: faCircleArrowUpRight,
      tooltip: 'exportInAdvanceTooltip',
      infoIcon: {
        icon: faInfoCircle,
        tooltip: 'exportInAdvanceTooltip',
      },
      disabledTooltip: 'exportInAdvanceDisabledTooltip',
      dataName: 'posts-preview-schedule-exportin-in-advance',
      dataCy: 'post-exportin-in-advance-dropdown-option',
    },
  };

export const publishNowOnlyOptions: Record<
  ScheduleMethodType,
  OptionConfig | undefined
> = {
  publishNow: {
    option: 'publishNow' as const,
    dataName: 'posts-preview-schedule-publish-now',
    dataCy: 'post-publish-now-dropdown-option',
    icon: faCircleCheck,
    tooltip: 'publishNowTooltip',
    disabledTooltip: 'publishNowDisabledTooltip',
  },
  createDarkPost: undefined,
  exportInAdvance: undefined,
};

const ALLOWED_PAGE_TYPES = [
  TYPE.FACEBOOK,
  TYPE.INSTAGRAM,
  TYPE.PINTEREST,
  TYPE.THREADS,
] as number[];

export function areOptionsEnabled(posts: Post[]) {
  return (
    posts.every((post) => ALLOWED_PAGE_TYPES.includes(post.page.type)) &&
    posts.length > 0
  );
}

export function getScheduleOptionsByPageType(): Record<
  number,
  Record<ScheduleMethodType, OptionConfig | undefined>
> {
  return {
    [TYPE.FACEBOOK]: facebookScheduleOptions,
    [TYPE.INSTAGRAM]: publishNowOnlyOptions,
    [TYPE.PINTEREST]: publishNowOnlyOptions,
    [TYPE.THREADS]: publishNowOnlyOptions,
  };
}
